/*
 * @Author: Src
 * @Date: 2025-08-08 13:43:24
 * @LastEditTime: 2025-08-08 13:45:06
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/services/car.service.ts
 * @Description: 头部注释配置模板
 */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

import { BASE_CAR_URL, BASE_URL } from '@/common/constant/index';





@injectable()
export default class CarService {
    @inject(HttpClient)
    protected http!: HttpClient;

    async getCarDetail(code: string) {
        try {
            const result = (await this.http.get(`${BASE_CAR_URL}/h5/detail/${code}`)) as any;
            return result;
        } catch (error) {
            return null;
        }
    }

}
